import React from 'react';
import styled, { css } from 'styled-components';
import { padding, layout } from 'styled-system';
import { palette, flexRow, flexCenter } from '../../constants/styles';
import Text from '../shared/Text';
import Markdown from 'markdown-to-jsx';

const StyledQuoteWrapper = styled.div`
  width: 100%;
  ${flexCenter}
`;
const StyledQuote = styled.div`
  ${layout}
  ${flexRow}
  margin: 20px 0px;
  align-self: center;
  justify-self: center;
`;

const StyledLeftPortion = styled.div`
  width: 4px;
  height: auto;
  background-color: #a5a5a5;
`;

const StyledRightPortion = styled.div`
  width: 100%;
  height: fit-content;
  background-color: ${palette.sweetGray};
  ${padding}
`;

export default function Quote({ quote, author }) {
  return (
    <StyledQuoteWrapper>
      <StyledQuote width={['300px', '500px']}>
        <StyledLeftPortion />
        <StyledRightPortion padding={['10px', '15px']}>
          <Text
            type="body2"
            styles={css`
              color: #a5a5a5;
              font-style: italic;
            `}
          >
            "{quote}"
          </Text>
          <Text
            type="body1"
            styles={css`
              color: #565656;
              font-style: italic;
            `}
          >
            <Markdown>{author}</Markdown>
          </Text>
        </StyledRightPortion>
      </StyledQuote>
    </StyledQuoteWrapper>
  );
}
